/**
 * 异常管理--故障上报列表
 */
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { message } from "antd";
import moment from "moment";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import ScGridTable from "@/components/display/table/gridTableCore";
import FormCore from "@/components/display/form/formCore";
import fetchHandler from "../../../fetch/fetchHandler";
// import { Tooltip } from 'antd';
import {
  stubErrorReport,
  ignoreFault,
  stubFaultReportedlevelData,
  getCityList,
  getUpdateTypeList,
  getFrameWorkList,
  getCodeNameList,
  prefixFile,
  stubDetailInfoApi,
  getModelNoList,
  getDicCodeList,
} from "../../../fetch/fetchApi";
import RefreshGrid from "../../../utils/refreshGrid";
import { useAuth } from "@/utils/utils";
// 国际化切换语言
// import { OPERATIONS_LEVEL } from '@/utils/mapObj';

// eslint-disable-next-line arrow-parens
@connect((state) => state)
class FaultReportingList extends PureComponent {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.faultReportingList;
    this.state = {
      visible: false,
      xhList: [],
      levelOption: [],
      formConfig: null,
      typeOption: [
        {
          text: this.props.intl.messages.faultReportingList.operationMode1, // '全部',
          value: "",
        },
      ],
    };
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  componentWillMount() {
    this.getLevel();
    this.getTiggerIdTypeType();
    this.setState({
      formConfig: this.initFormConfig(),
    });
    this.init();
  }

  componentDidMount() {
    let param = {
      errorType: 1,
      tiggerId: '',
      date: `${moment(new Date()).subtract(29, "d").format("YYYY-MM-DD")},${moment(new Date())
        .subtract(0, "d")
        .format("YYYY-MM-DD")}`,
    };
    if (window.LayoutTab && window.LayoutTab.tabParam) {
      const date = window.LayoutTab.tabParam.date;
      param = {
        ...param,
        ...window.LayoutTab.tabParam,
        date: `${date[0].format("YYYY-MM-DD")},${date[1].format("YYYY-MM-DD")}`,
      };
    }
    this.fetchApi(param);
  }

  //获取触发方
  getTiggerIdTypeType() {
    fetchHandler(getDicCodeList, {
      code: "maint.statustigger",
    }).then((res) => {
      if (res.data && res.code === "success") {
        let newList =res.data.map((item) => {
          return {
            text: item.name,
            value: item.code,
          };
        });
        newList.unshift({
          text: "全部",
          value: "",
        })
        this.setState(
          {
            tiggerIdTypeOption: newList
          },
          () => {
            this.setState({
              formConfig: this.initFormConfig(),
            });
          },
        );
      }
    });
  }
  // 获取故障等级
  getLevel() {
    fetchHandler(stubFaultReportedlevelData, {
      type: "1",
    }).then((res) => {
      // console.log(res);
      const list = res.data.map((item) => {
        const foo = {
          text: item.name,
          value: item.id,
        };
        return foo;
      });
      const first = {
        text: this.internationalization.operationMode1, // '全部',
        value: "",
      };
      list.unshift(first);
      this.setState(
        {
          levelOption: [...list],
        },
        () => {
          this.setState({
            formConfig: this.initFormConfig(),
          });
        },
      );
      this.init();
    });
  }

  exportOrderStuGroup = (paramString) => {
    const excelUrl = `${prefixFile}/exportStubFaultReported.do`;
    const ele = document.createElement("a");
    ele.download = encodeURI(`${excelUrl}?${paramString}`);
    ele.style.display = "none";
    ele.href = encodeURI(`${excelUrl}?${paramString}`);
    ele.target = "_blank"; // 针对 ie模式 的浏览器
    // 触发点击
    document.body.appendChild(ele);
    ele.click();
    // 然后移除
    document.body.removeChild(ele);
  };

  init() {
    this.setState({
      tableConfig: {
        tableKey: "faultReportingListTable",
        tableColumns: [
          {
            name: this.internationalization.title7, // 7'设备编号',
            key: "stubId",
            colType: "textCol",
            align: "left",
            render: (value, row) => {
              return (
                <div
                  onClick={(e) => {
                    if (row.tiggerId == 2) {
                      this.openTab(
                        {
                          // keyId: `stub_${record.key}`,
                          // StubName: record.name,
                          stubId: row.stubId,
                        },
                        {
                          key: "0107",
                          titleText: "地锁查询", // '设备快速查询',
                        },
                      );
                    } else {
                      this.openTab(
                        {
                          // keyId: `stub_${record.key}`,
                          // StubName: record.name,
                          stubId: row.stubId,
                        },
                        {
                          key: "0102",
                          titleText: "设备快速查询", // '设备快速查询',
                        },
                      );
                    }
                  }}>
                  <a>{row.stubId}</a>
                </div>
              );
            },
          },
          {
            name: "触发方", // '触发方'
            key: "tiggerId",
            align: "left",
            width: 80,
            colType: "textCol",
            render: (value, row) => {
              // switch (value) {
              //   case 0:
              //     return ""; // '';
              //   case 1:
              //     return "桩"; // '桩';
              //   case 2:
              //     let br = "";
              //     if (row.lockBrand == 0) {
              //       br = "开迈斯地锁";
              //     } else if (row.lockBrand == 1) {
              //       br = "蓝牙";
              //     } else if (row.lockBrand == 2) {
              //       br = "慧铂金";
              //     } else if (row.lockBrand == 3) {
              //       br = "万科地锁";
              //     } else if (row.lockBrand == 4) {
              //       br = "丁丁地锁";
              //     } else if (row.lockBrand == 5) {
              //       br = "豪位地锁";
              //     }
              //     return `地锁：${br}`; // '地锁';
              //   case 3:
              //     return "智能巡检";
              //     case 4:
              //       return "平台";
              //   default:
              //     return "未知"; // '未知'
              // }
              return <div>{row.tiggerName ? row.tiggerName : "--"}</div>;
            },
          },
          {
            name: this.internationalization.title8, // '故障码',
            key: "code",
            colType: "textCol",
            align: "left",
          },
          {
            name: "是否告警项", // '是否告警项'
            key: "errorType",
            align: "left",
            width: 80,
            colType: "textCol",
            render: (value) => {
              switch (value) {
                case 0:
                  return ""; // '';
                case 1:
                  return "是"; // '是';
                case 2:
                  return "否"; // '否';
                default:
                  return "未知"; // '未知'
              }
            },
          },
          {
            name: "告警项状态", // '告警项状态'
            key: "offType",
            align: "left",
            width: 80,
            colType: "textCol",
            render: (value, row) => {
              let statusInfo = "--";
              if (row.errorType == 1) {
                if (row.excStatus == 1) {
                  statusInfo = "待处理";
                } else if (row.excStatus == 2) {
                  statusInfo = "已处理";
                } else if (row.excStatus == 3) {
                  statusInfo = "已忽略";
                } else if (row.excStatus == 4) {
                  statusInfo = "无需处理";
                }
              }
              if (statusInfo != "--") {
                if (row.offType == 2) {
                  return (
                    <div
                      style={{
                        color: "red",
                      }}>
                      <span>{statusInfo}</span>
                    </div>
                  );
                } else {
                  return (
                    <div
                      style={{
                        color: "black",
                      }}>
                      <span>{statusInfo}</span>
                    </div>
                  );
                }
              } else {
                return (
                  <div
                    style={{
                      color: "black",
                    }}>
                    <span>{statusInfo}</span>
                  </div>
                );
              }
            },
          },
          {
            name: "超时状态", // '超时状态'
            key: "offType",
            align: "left",
            width: 80,
            colType: "textCol",
            render: (value, row) => {
              let statusInfo = "--";
              if (row.offType == 1) {
                statusInfo = "否";
              } else if (row.offType == 2) {
                statusInfo = "是";
              } else {
                statusInfo = "--";
              }
              if (statusInfo != "--") {
                if (row.offType == 2) {
                  return (
                    <div
                      style={{
                        color: "red",
                      }}>
                      <span>{statusInfo}</span>
                    </div>
                  );
                } else {
                  return (
                    <div
                      style={{
                        color: "black",
                      }}>
                      <span>{statusInfo}</span>
                    </div>
                  );
                }
              } else {
                return (
                  <div
                    style={{
                      color: "black",
                    }}>
                    <span>{statusInfo}</span>
                  </div>
                );
              }
            },
          },
          {
            name: this.internationalization.title9, // '故障名称',
            key: "codeName",
            colType: "tipCol",
            align: "left",
          },

          {
            name: "设备类型", // '设备类型'
            key: "stubType",
            align: "left",
            width: 100,
            colType: "textCol",
            render: (value) => {
              switch (value) {
                case 0:
                  return "交流电"; // '交流电';
                case 1:
                  return "直流电"; // '直流电';
                case 2:
                  return "交直流"; // '交直流';
                default:
                  return "未知"; // '未知'
              }
            },
          },
          {
            name: this.internationalization.title10, // '运维等级',
            colType: "textCol",
            width: 100,
            align: "left",
            render: (value, row) => {
              return (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    padding: "0 10px",
                  }}>
                  <div className="tip-lv">
                    <span className="first" style={{ background: row.color }}></span>
                    <span className="last" style={{ background: row.color }}></span>
                  </div>
                  <span>{row.maintLevelName}</span>
                </div>
              );
            },
          },
          {
            name: this.internationalization.title11, // '次数',
            key: "cnt",
            align: "center",
            colType: "numCol",
          },
          {
            name: this.internationalization.title12, // '最新上报时间',
            key: "reportTimeLatest",
            colType: "textCol",
            align: "left",
          },
          {
            name: "场站名称", // '场站名称',
            key: "stubGroupName",
            colType: "tipCol",
            align: "left",
          },
          {
            name: this.internationalization.title14, // '地区',
            key: "cityName",
            colType: "textCol",
            align: "left",
          },
          {
            name: "运营类型", // '运营类型',
            key: "operationMode",
            colType: "textCol",
            align: "left",
            width: 120,
            render: (value) => {
              if (value.toString() === "1") {
                return "直营";
              } else if (value.toString() === "0") {
                return "非直营";
              } else {
                return "--";
              }
            },
          },
          {
            name: this.internationalization.title16, // '设备型号',
            key: "modelNo",
            colType: "textCol",
            align: "left",
            render: (value) => {
              if (value === "null") {
                return "--";
              } else {
                return value;
              }
            },
          },
          {
            name: "固件信息",
            colType: "textCol",
            align: "left",
            render: (value, row) => {
              const updateType =
                row.updateType === "null" || row.updateType === "全部" ? "-" : row.updateType;
              const frameWork =
                row.frameWork === "null" || row.updateType === "全部" ? "" : row.frameWork;

              const text = `${updateType}-${frameWork}`;
              return <div>{text}</div>;
            },
          },
          // {
          //   name: "告警模型",
          //   key: "faultModel",
          //   colType: "textCol",
          //   align: "left",
          // },
          {
            name: "工单编号",
            key: "ticketId",
            colType: "textCol",
            align: "left",
          },
          {
            name: "详情",
            key: "detail",
            colType: "tipCol",
            align: "left",
          },
          {
            name: "备注",
            key: "remark",
            colType: "tipCol",
            align: "left",
          },
          {
            name: "操作",
            key: "action",
            colType: "action", // 操作列，可定义多种操作。
            fix: "right",
            width: 80,
            align: "center",
            actionMap: [
              useAuth("040103")
                ? {
                    type: "href",
                    actionName: "一键报修", 
                    handler: (res) => {
                      this.goBao(res);
                    },
                  }
                : "",
              useAuth("040104")
                ? {
                    type: "confirm",
                    actionName: "忽略",
                    popText: () => {
                      return `确定要忽略该告警吗？`;
                    },
                    render: (record) => {
                      if (record.excStatus && record.excStatus == 1) {
                        return <span>忽略</span>;
                      } else {
                        return null;
                      }
                    },
                    handler: (record) => {
                      // console.info("请求");
                      // console.info(record);
                      fetchHandler(ignoreFault, {
                        stubId: record.stubId,
                        code: record.code,
                        dateTime: record.dateTime,
                      }).then((res) => {
                        if (res && (res.code === "ok" || res.code === "success")) {
                          message.success("忽略成功");
                          RefreshGrid(this.context.store, "faultReportingListTable");
                        }
                      });
                    },
                  }
                : "",
            ],
          },
        ],
        tableChange: () => {},
        tableParam: {
          pagecount: 10,
        },
        dataApi: stubErrorReport,
        autoRefresh: !1, // 设置为true 直接加载grid数据
      },
    });
  }

  initFormConfig = () => {
    const formConfig = {
      childItems: [
        {
          type: "autoWatch",
          placeholder: this.internationalization.placeholder1, // '请输入故障名称:',
          param: {
            name: "codeName",
            type: "string",
          },
          labelName: this.internationalization.title1, // '故障名称',
          required: !1,
          sourceApi: getCodeNameList,
        },
        {
          type: "input",
          placeholder: "请输入电站名称", // '请输入',
          param: {
            name: "stationName",
            type: "string",
          },
          labelName: "电站名称", // '故障名称:',
          required: false,
        },
        {
          type: "input",
          placeholder: this.internationalization.placeholder2, // '请输入设备编号',
          param: {
            name: "stubId",
            type: "string",
          },
          labelName: this.internationalization.title2, // '设备编号:',
          required: false,
          defaultValue:
            window.LayoutTab && window.LayoutTab.tabParam && window.LayoutTab.tabParam.stubId,
        },
        {
          type: "areaPicker",
          isPickArea: !0,
          placeholder: this.internationalization.placeholder3, // '请选择地区',
          pickOnSelect: true,
          param: {
            name: "cityId", // 与form表单绑定的参数名
            type: "array",
          },
          // defaultValue: ['34'], //默认值
          required: !1,
          labelName: this.internationalization.title3, // '地区',
          className: "allshow",
          sourceApi: getCityList,
          mapKey: {
            label: "label",
            value: "value",
            children: "children",
          },
        },
        {
          type: "select",
          options: this.state.levelOption,
          placeholder: this.internationalization.placeholder, // '请选择:',
          param: {
            name: "maintLevelId",
            type: "string",
          },
          labelName: this.internationalization.title4, // '运维等级',
          required: !1,
        },
        {
          type: "select",
          options: [
            {
              text: "全部", // '全部',
              value: "",
            },
            {
              text: "交流电", // '交流电',
              value: "0",
            },
            {
              text: "直流电", // '直流电',
              value: "1",
            },
            {
              text: "交直流", // '交直流',
              value: "2",
            },
          ],
          placeholder: "请选择", // '请选择设备类型',
          param: {
            name: "stubType",
            type: "string",
          },
          labelName: "设备类型", // '设备类型',
          required: false,
        },
        {
          type: "select",
          placeholder: "请选择", // '请选择设备状态',
          labelName: "是否为告警项", // '设备状态',
          param: {
            name: "errorType",
            type: "string",
          },
          defaultValue: "1",
          options: [
            {
              text: "全部",
              value: "",
            },
            {
              text: "是",
              value: "1",
            },
            {
              text: "否",
              value: "2",
            },
          ],
          required: false,
        },
        {
          type: "select",
          placeholder: "请选择", // '请选择触发方类型',
          labelName: "触发方", // '触发方类型',
          param: {
            name: "tiggerId",
            type: "string",
          },
          defaultValue: "",
          options: this.state.tiggerIdTypeOption,
          // options: [
          //   {
          //     text: "全部",
          //     value: "",
          //   },
          //   {
          //     text: "充电桩",
          //     value: "1",
          //   },
          //   {
          //     text: "地锁",
          //     value: "2",
          //   },
          //   {
          //     text: "智能运维",
          //     value: "3",
          //   },
          //   {
          //     text: "平台",
          //     value: "4",
          //   },
          // ],
          required: false,
        },
        {
          type: "select",
          placeholder: "请选择", // '请选择设备状态',
          labelName: "运营类型", // '设备状态',
          param: {
            name: "operationMode",
            type: "string",
          },
          options: [
            {
              text: "全部",
              value: "",
            },
            {
              text: "非直营",
              value: "0",
            },
            {
              text: "直营",
              value: "1",
            },
          ],
          required: false,
        },
        {
          type: "date",
          dateType: "rangeDate",
          allowClear: false,
          width: "200px",
          placeholder: ["年/月/日", "年/月/日"],
          param: {
            name: "date",
            type: "array",
          },
          defaultValue:
            window.LayoutTab && window.LayoutTab.tabParam && window.LayoutTab.tabParam.date
              ? window.LayoutTab.tabParam.date
              : [moment(new Date()).subtract(7, "d"), moment(new Date()).subtract(0, "d")],

          validator: {
            // 自定义校验对象
            vtype: "date", // 校验名称
            min_val: 0, // 可选最小天数
            max_val: 92, // 可选最大天数
          },
          labelName: this.internationalization.title6, // '日期:',
          required: true,
        },

        {
          type: "autoWatch",
          placeholder: this.internationalization.title18, // '请选择:',
          param: {
            name: "modelNo",
            type: "string",
          },
          labelName: this.internationalization.title16, // '设备型号',
          required: !1,
          sourceApi: getModelNoList,
        },
        {
          type: "inputGroup",
          isArray: true,
          inputGroup: [
            {
              type: "select",
              placeholder: this.internationalization.title17, // '固件型号:',
              width: "95px",
              param: {
                name: "updateType",
                type: "string",
              },

              labelName: this.internationalization.wz3, // '固件信息','固件信息:',
              dataApi: { api: getUpdateTypeList, loaded: !1, addAll: true },
              required: false,
              onChange: async (value, form) => {
                form.setFieldsValue({
                  frameWork: "",
                  updateType: value,
                });
                fetchHandler(getFrameWorkList, {
                  updateType: value,
                }).then((res) => {
                  const finalData = res.data;
                  finalData.unshift("全部");
                  this.setState(
                    {
                      xhList: finalData.map((v) => {
                        return {
                          text: v,
                          value: v,
                        };
                      }),
                    },
                    () => {
                      this.setState({
                        formConfig: this.initFormConfig(),
                      });
                    },
                  );
                });
              },
            },
            {
              type: "select",
              placeholder: this.internationalization.title19, // '固件版本:',
              width: "95px",
              param: {
                name: "frameWork",
                type: "string",
              },
              options: this.state.xhList,
              required: false,
            },
          ],
        },

        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [
            useAuth("040101")
              ? {
                  btnType: "submit",
                  // icon: 'search',
                  text: this.internationalization.btn1, // '查询'
                }
              : "",
            useAuth("040102")
              ? {
                  btnType: "button",
                  text: "导出", // '导出',
                  handler: (e, param) => {
                    const newParam = param;
                    newParam.flag = 1;
                    newParam.token = window.sessionStorage.getItem("token");
                    newParam.companyId = window.sessionStorage.getItem("companyId");
                    let paramString = "";
                    const date = newParam.date.split(",");
                    newParam.startTime = date[0];
                    newParam.endTime = date[1];
                    newParam.cityId =
                      newParam.cityId === undefined
                        ? ""
                        : newParam.cityId
                            .toString()
                            .slice(
                              newParam.cityId.toString().lastIndexOf(",") + 1,
                              newParam.cityId.toString().length,
                            );
                    Object.keys(newParam).forEach((key) => {
                      const paraminfo = newParam[key] ? newParam[key] : "";
                      paramString += `${key}=${paraminfo}&`;
                    });
                    this.exportOrderStuGroup(paramString);
                  },
                }
              : "",
          ],
        },
      ],
      layout: "inline", // 设置布局 0： 横向布局， 1：纵向布局
      formTarget: "submit", // 表单提交类型，设置grid则为更新grid
      autoLoadGrid: !1, // 设置为false不触发加载grid
      context: this,
      defaultParams: {
        operationProperty: "3",
        errorType: "1",
      },
      tableKey: "faultReportingListTable",
      tablePage: "故障上报",
    };

    return formConfig;
  };

  fetchApi = (param) => {
    // console.info("囫");
    const newParam = param;
    const data = [param.date.split(",")[0], param.date.split(",")[1]];
    if (
      newParam.frameWork == null ||
      newParam.frameWork == "null" ||
      newParam.frameWork == "全部"
    ) {
      newParam.frameWork = "";
    }
    if (
      newParam.updateType == null ||
      newParam.updateType == "null" ||
      newParam.updateType == "全部"
    ) {
      delete newParam.updateType;
    }
    newParam.cityId =
      newParam.cityId === undefined
        ? ""
        : newParam.cityId
            .toString()
            .slice(
              newParam.cityId.toString().lastIndexOf(",") + 1,
              newParam.cityId.toString().length,
            );
    newParam.startTime = data[0];
    newParam.endTime = data[1];
    delete newParam.date;

    newParam.operationProperty = "3";

    // 当设置formTarget为grid时，执行自定义提交事件。
    if (this.state.formConfig.formTarget === "grid") {
      return;
    }
    // 请求fetch 对象，带入生成参数
    // 如果在modal中的表单提交，请执行这里
    if (this.props.modalSubmit) {
      return this.props.modalSubmit(newParam);
    } else {
      // 如果正常页面中的表单提交，请执行下面
      return RefreshGrid(this.context.store, "faultReportingListTable", newParam);
    }
  };

  openTab(param, e) {
    this.props.onAdd.bind(window.LayoutTab)(e, param);
  }

  goBao(res) {
    fetchHandler(stubDetailInfoApi, {
      stubId: res.stubId,
    }).then((result) => {
      // console.log('goBao:',result);
      if(result.data){
        window.sessionStorage.removeItem("serviceProvider");
        window.sessionStorage.removeItem("proXType");
        window.sessionStorage.removeItem("isThird");
        window.sessionStorage.removeItem("deee");
        window.sessionStorage.removeItem("hideModal");
        this.openTab(
          {
            // keyId: `stub_${record.key}`,
            // StubName: record.name,
            initSetting: {
              ticketType:  res.tiggerId == '11' ? 90: 89,
              code: res.code,
              tiggerId: res.tiggerId,
              // stubId: res.stubId,
              stuInfo:{
                data:{
                  ...result.data,
                  dateTime:res.dateTime
                }
              },
              codeName: res.codeName,
              isFaultReport: true,
            },
          },
          {
            key: "9103create",
            titleText: "创建工单", // '设备快速查询',
          },
        );
      }
    });
  }

  render() {
    const Content = (
      <div className="sc-page-content">
        <div className="page-toolbar">
          <FormCore formConfig={this.state.formConfig} fetchApi={this.fetchApi} />
        </div>
        <div className="page-panel gzsbTable">
          <ScGridTable config={this.state.tableConfig} />
        </div>
      </div>
    );

    return Content;
  }
}

export default injectIntl(FaultReportingList);



// WEBPACK FOOTER //
// ./src/AntD/pages/exceptionManagement/faultReporting/faultReportingList.js